<div class="grid grid-cols-12 gap-4 mt-0 mb-0">
  <app-form-field [control]="message" [full]="true" i18n-label inputId="message" label="Nachricht">
    <textarea [autoResize]="true" [formControl]="message" [rows]="10" id="message" pInputTextarea></textarea>
  </app-form-field>
</div>
<div class="flex gap-2">
  <app-button
    (onClick)="close()"
    [hideLabelOnSmall]="false"
    [outlined]="true"
    i18n-label
    icon="close"
    label="Abbrechen" />
  <app-button
    (onClick)="send()"
    [disabled]="message.invalid"
    [hideLabelOnSmall]="false"
    i18n-label
    icon="send"
    label="Senden" />
</div>
